<div id="selection-popup" class="warning-popup">
    <h2 class="m-b-10" mat-dialog-title>{{title | titlecase}}</h2>
    <div mat-dialog-content id="leave-popup-fields">
        <div>
            <form [formGroup]="form">
                <div class="d-flex">
                    <div fxFlex="100" fxFlex.gt-sm="20" class=" m-r-10">
                        <mat-form-field floatLabel="always" class="w-100">
                            <input formControlName="fecha" matInput [matDatepicker]="date" placeholder="Fecha"
                                (click)="date.open()">
                            <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
                            <mat-datepicker #date></mat-datepicker>
                        </mat-form-field>
                        <mat-error class="validation-error" *ngIf="form.get('fecha').invalid">
                            <span *ngIf="form.get('fecha').errors.minDate" class="validation-span">
                                La fecha debe estar entre la fecha de comunicación y hoy</span>
                            <span *ngIf="form.get('fecha').errors.maxDate" class="validation-span">
                                La fecha de la visita no puede ser superior a hoy</span>
                        </mat-error>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class=" m-r-10">
                        <mat-form-field class="example-full-width respuesta-field" floatLabel="always">
                            <mat-label>Respuesta</mat-label>
                            <mat-select formControlName="respuestaSolicitud" (selectionChange)="replyTypeChange()">
                                <mat-option *ngFor="let item of replyTypes" [value]="item.value">
                                    {{item.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="30">
                        <mat-form-field *ngIf="form.value.respuestaSolicitud" floatLabel="always">
                            <input formControlName="frespuestaSolicitud" matInput [matDatepicker]="replaydate"
                                placeholder="F. Respuesta" (click)="replaydate.open()">
                            <mat-datepicker-toggle matSuffix [for]="replaydate"></mat-datepicker-toggle>
                            <mat-datepicker #replaydate></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <div class="d-flex">
                    <div fxFlex="100" fxFlex.gt-sm="20" class=" m-r-10">
                        <mat-form-field class="example-full-width" floatLabel="always">
                            <input formControlName="fprogramadaSolicitud" matInput [matDatepicker]="sheduleDate"
                                placeholder="F. Programada" (click)="sheduleDate.open()">
                            <mat-datepicker-toggle matSuffix [for]="sheduleDate"></mat-datepicker-toggle>
                            <mat-datepicker #sheduleDate></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="20" class=" m-r-10">
                        <mat-form-field floatLabel="always">
                            <input formControlName="frealizacionSolicitud" matInput [matDatepicker]="realizationDate"
                                placeholder="F. Realización" (click)="realizationDate.open()">
                            <mat-datepicker-toggle matSuffix [for]="realizationDate"></mat-datepicker-toggle>
                            <mat-datepicker #realizationDate></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="55">
                        <mat-form-field *ngIf="form.value.respuestaSolicitud" class="example-full-width"
                            floatLabel="always">
                            <mat-label>Justificación</mat-label>
                            <mat-select formControlName="justificacionSolicitud">
                                <mat-option *ngFor="let item of justificationsList" [value]="item.value">
                                    {{item.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <mat-form-field class="example-full-width textarea" floatLabel="always">
                    <textarea matInput rows="3" placeholder="Informe" formControlName="comentarios"></textarea>
                </mat-form-field>
            </form>
        </div>
        <div class="text-a-r p-t-5">
            <button mat-raised-button color="accent" class="m-r-15" (click)="save()">Aceptar</button>
            <button mat-raised-button color="warn" (click)="close()">Cancelar</button>
        </div>
    </div>
</div>